import IdleMonitor from './idleMonitor';

const monitor = new IdleMonitor();

export default function idleMonitorPlugin({ commit }) {
  monitor.on('useridle', () => commit('setUserIdle', true));
  monitor.on('useractive', () => commit('setUserIdle', false));
  monitor.start();
}
